export const BREAKPOINTS = {
  XL: 1400,
  LG: 1200,
  MD: 991,
  SM: 767,
  XS: 575,
};
